import gql from 'graphql-tag';

const DISABLE_NYLAS_INTEGRATION = gql`
  mutation DisableNylasIntegration {
      disableNylasIntegration
  }
`;

export default DISABLE_NYLAS_INTEGRATION;
